import React from "react"
import { Helmet } from "react-helmet"
import { Value } from "contentful-layout-field"
import { FluidObject } from "gatsby-image"
import SEO from "../components/boilerplate/seo"
import LayoutBuilder from "../components/LayoutBuilder"
import SEOBlock from "../components/SEOBlock"
import ContentfulRichText from "../components/ContentfulRichText"
import Body from "../components/typography/Body"
import { createContentfulImageMap } from "../utils"
import useBreakpointValue from "../hooks/useBreakpointValue"
import { bp } from "../utils/MediaQueries"
import { sanitizeFluidObject } from "../utils/redirects"
import { HomePageQuery } from "../../graphql-types"
import FittingConsultationWidget from "../components/FittingConsultationWidget"
import CatalogDownloadWidget from "../components/CatalogDownloadWidget"

type HomePageProps = {
  data: HomePageQuery
  pageContext: {
    layoutData: Value
    seoTitle: string
    seoDescription: string
    seoContentBlock?: {
      raw?: string | null
    } | null
  }
  location: Location
}

const HomePage: React.FC<HomePageProps> = ({ data, pageContext, location }) => {
  const desktopImageMap = createContentfulImageMap(data.images)
  const mobileImageMap = createContentfulImageMap(data.mobileImages)
  const imageMap = useBreakpointValue(bp(mobileImageMap, desktopImageMap))
  const seoBackgroundImage =
    data.home?.edges?.[0]?.node?.seoBackgroundImage?.fluid

  return (
    <>
      <SEO
        title={pageContext.seoTitle}
        description={pageContext.seoDescription}
        location={location}
      />
      <Helmet>
        <link
          type="application/opensearchdescription+xml"
          rel="search"
          href="opensearch.xml"
        />
      </Helmet>
      <FittingConsultationWidget />
      <LayoutBuilder
        data={pageContext.layoutData}
        imageMap={imageMap}
        delayRender
        mt={bp("0", "3rem")}
      />
      {pageContext.seoContentBlock?.raw && (
        <SEOBlock
          label={`Learn more about ${pageContext.seoTitle || "Sixthreezero"}`}
          mb="80"
          className="seo-content-block"
          image={sanitizeFluidObject(seoBackgroundImage) as FluidObject}
        >
          <Body as="h2" fontWeight="bold" mb="20">
            {pageContext.seoTitle}
          </Body>
          <ContentfulRichText richText={pageContext.seoContentBlock} />
        </SEOBlock>
      )}
      <CatalogDownloadWidget />
    </>
  )
}

export default HomePage
